const Cookies = {
  PINCODE: 'PC'
};
export default Cookies;
